import React, { useEffect, useState } from 'react';
import { BsX } from 'react-icons/bs';

import * as S from './styles';
import { getActiveCampaign } from '../../config/loginCampaigns';

const BANNER_KEY = '@AcordeOn:showLoginBanner';

const LoginBannerModal = () => {
  const [campaign, setCampaign] = useState(null);

  useEffect(() => {
    if (sessionStorage.getItem(BANNER_KEY) === 'true') {
      sessionStorage.removeItem(BANNER_KEY);

      const activeCampaign = getActiveCampaign();

      if (activeCampaign) {
        setCampaign(activeCampaign);
      }
    }
  }, []);

  if (!campaign) return null;

  const handleClose = () => setCampaign(null);

  const banner = (
    <>
      <S.BannerDesktop src={campaign.bannerDesktop} alt={campaign.alt} />
      <S.BannerMobile src={campaign.bannerMobile} alt={campaign.alt} />
    </>
  );

  return (
    <S.Overlay onClick={handleClose}>
      <S.Container onClick={e => e.stopPropagation()}>
        <S.CloseButton type="button" onClick={handleClose} aria-label="Fechar">
          <BsX size={28} />
        </S.CloseButton>
        {campaign.link ? (
          <a href={campaign.link} target="_blank" rel="noopener noreferrer">
            {banner}
          </a>
        ) : (
          banner
        )}
      </S.Container>
    </S.Overlay>
  );
};

export default LoginBannerModal;
